export default __webpack_public_path__ + "static/media/Leggings of the Crawling Chaos.b2921be8.jpg";